import clsx from 'classnames';
import React from 'react';
import { withStyles } from '@material-ui/core';
import Cell from './Cell';
function styles() {
	return {
		corner: {
			padding: `10px 10px`,
			backgroundColor: '#f2f2f2',
			textAlign: 'left',
			fontWeight: 800,
			textTransform: 'uppercase',
			color: '#666',
		},
		cornerForDriverRoom: {
			padding: `3px 10px`,
			backgroundColor: '#f2f2f2',
			textAlign: 'left',
			fontWeight: 800,
			textTransform: 'uppercase',
			color: '#666',
			fontSize: '140%',
		},
		date: {
			backgroundColor: '#EFEEEF',
			padding: `10px 3px`,
			textAlign: 'center',
			fontWeight: 800,
			textTransform: 'uppercase',
			color: '#666',
		},
		forDriverRoom: {
			padding: `2px 2px`,
			fontSize: '130%',
			fontWeight: 800,
		},
		dateToday: {
			backgroundColor: '#CDDAEF',
			borderColor: '#4A90E2',
			color: '#0973B6',
			borderLeft: '1px solid',
		},
	};
}

function DateHeader({ classes, dateColumns, today, isDriverRoom, cornerDisplay }) {
	return (
		<tr>
			<Cell
				className={isDriverRoom ? classes.cornerForDriverRoom : classes.corner}
				isTableHeader={true}
			>
				{cornerDisplay || 'DRIVER'}
			</Cell>
			{!isDriverRoom && (
				<>
					<Cell
						className={isDriverRoom ? classes.cornerForDriverRoom : classes.corner}
						isTableHeader={true}
					>
						SHIFT
					</Cell>
				</>
			)}
			{dateColumns.map((header) => {
				const cellClassNames = [classes.date];
				if (today === header.date) {
					cellClassNames.push(classes.dateToday);
				}

				if (isDriverRoom) {
					cellClassNames.push(classes.forDriverRoom);
				}

				return (
					<Cell
						key={header.date}
						numberOfDays={dateColumns.length}
						isTableHeader={true}
						className={clsx(cellClassNames)}
					>
						{header.display}
					</Cell>
				);
			})}
		</tr>
	);
}

export default withStyles(styles)(DateHeader);
